import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=0c955521&scoped=true&"
import script from "./AdBanner.vue?vue&type=script&lang=js&"
export * from "./AdBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=0c955521&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c955521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VList})
